import * as browser from "webextension-polyfill";
import { getStoredCommandIds } from "./command-library";
import { CommandName, CommandVersion } from "./command-library.types";
import { DataType, LicenseState, PlatformStatus, PlatformType, eventStorageKey, } from "./data-collection.types";
import { getStartInfo } from "./start-info";
import { getIPMPingCount } from "./telemetry";
function leftPad(value) {
    return value.toString().padStart(2, "0");
}
function getLocalTimeStamp() {
    const date = new Date();
    return [
        date.getFullYear(),
        "-",
        leftPad(date.getMonth() + 1),
        "-",
        leftPad(date.getDate()),
        "T",
        leftPad(date.getHours()),
        ":",
        leftPad(date.getMinutes()),
        ":",
        leftPad(date.getSeconds()),
    ].join("");
}
async function getBaseAttributes() {
    const { info } = getStartInfo();
    return {
        app_name: info.getAppName(),
        browser_name: info.getBrowserName(),
        browser_version: info.getBrowserVersion(),
        os: (await browser.runtime.getPlatformInfo()).os,
        language_tag: browser.i18n.getUILanguage(),
        app_version: info.getAppVersion(),
        install_type: (await browser.management.getSelf()).installType,
        manifest_version: browser.runtime.getManifest().manifest_version,
    };
}
async function getEventData(ipmId, commandName, commandVersion, name) {
    const { info } = getStartInfo();
    return {
        type: DataType.event,
        device_id: await info.getId(),
        action: name,
        platform: PlatformType.web,
        app_version: info.getAppVersion(),
        user_time: getLocalTimeStamp(),
        attributes: {
            ...(await getBaseAttributes()),
            ipm_id: ipmId,
            command_name: commandName,
            command_version: commandVersion,
        },
    };
}
async function getDeviceData() {
    const { info, licensing, getBlockCount } = getStartInfo();
    return {
        type: DataType.device,
        device_id: await info.getId(),
        attributes: {
            ...(await getBaseAttributes()),
            extension_id: browser.runtime.id,
            blocked_total: await getBlockCount(),
            license_status: (await licensing.isLicenseValid())
                ? LicenseState.active
                : LicenseState.inactive,
        },
    };
}
async function getUserData() {
    return {
        type: DataType.customer,
        platforms: [{ platform: PlatformType.web, active: PlatformStatus.true }],
        attributes: {
            ...(await getBaseAttributes()),
            ping_count: await getIPMPingCount(),
        },
    };
}
export function getSupportedCommandsData() {
    const commandNames = Object.values(CommandName);
    const supportedCommandsData = commandNames.map((name) => ({
        name,
        version: CommandVersion[name],
    }));
    return supportedCommandsData;
}
function getIpmData() {
    return {
        active: getStoredCommandIds().map((id) => ({ id })),
        capabilities: [
            {
                name: "multi_ipm_response",
                version: 1,
            },
            ...getSupportedCommandsData(),
        ],
    };
}
export async function getPayload() {
    const { prefs } = getStartInfo();
    await prefs.untilLoaded;
    const user = await getUserData();
    const device = await getDeviceData();
    const events = prefs.get(eventStorageKey);
    const ipm = getIpmData();
    return { user, device, events, ipm };
}
export async function clearEvents() {
    const { prefs } = getStartInfo();
    await prefs.untilLoaded;
    void prefs.set(eventStorageKey, []);
}
export async function storeEvent(ipmId, commandName, commandVersion, name) {
    const { prefs } = getStartInfo();
    await prefs.untilLoaded;
    const eventData = await getEventData(ipmId, commandName, commandVersion, name);
    const eventStorage = prefs.get(eventStorageKey);
    eventStorage.push(eventData);
    void prefs.set(eventStorageKey, eventStorage);
}
